import { layoutText, measureFit, resolveLayout, textCapacityFor, } from '@kitup/book-schema';
function candidates(attributes) {
    const base = attributes.typography.baseSizePt;
    const [a, b] = attributes.typography.autoFitPt;
    const lo = Math.min(a, b);
    const hi = Math.min(Math.max(a, b), base);
    const result = [base];
    for (let size = hi; size >= lo - 1e-9; size -= 0.5) {
        const candidate = Math.round(size * 2) / 2;
        if (!result.includes(candidate))
            result.push(candidate);
    }
    return result;
}
/**
 * Производит блоки и выбирает наибольший допустимый кегль для конкретной сцены.
 * В отличие от общего `autoFitSizePt`, учитывает оба слота full-bleed и
 * индивидуальный `bandImageRatio` сцены.
 */
export function prepareSpreadText(scene, attributes) {
    const layoutId = resolveLayout(scene, attributes);
    let lastBlocks = [];
    let lastOverflow = 0;
    let lastSize = attributes.typography.baseSizePt;
    for (const fontSizePt of candidates(attributes)) {
        const blocks = layoutText(scene.textRu, layoutId, attributes, {
            previous: scene.textBlocks,
            sizePt: fontSizePt,
        });
        const capacity = textCapacityFor(layoutId, attributes, fontSizePt, scene);
        const measures = blocks.map((block) => measureFit(block.text, capacity));
        const overflowCharacters = measures.reduce((sum, measure) => sum + measure.overflowChars, 0);
        lastBlocks = blocks;
        lastOverflow = overflowCharacters;
        lastSize = fontSizePt;
        if (measures.every((measure) => measure.fits)) {
            return { blocks, fontSizePt, fits: true, overflowCharacters: 0 };
        }
    }
    return {
        blocks: lastBlocks,
        fontSizePt: lastSize,
        fits: false,
        overflowCharacters: lastOverflow,
    };
}
//# sourceMappingURL=text.js.map